import React, { createContext, useContext, useEffect, useState } from "react";
import { t } from "@/lib/i18n";

const LangContext = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("uk_lang") || "tr");
  useEffect(() => { localStorage.setItem("uk_lang", lang); document.documentElement.lang = lang; }, [lang]);
  const translate = (key) => t(lang, key);
  return (
    <LangContext.Provider value={{ lang, setLang, t: translate }}>
      {children}
    </LangContext.Provider>
  );
}

export const useLang = () => useContext(LangContext);
